import dynamic from 'next/dynamic';
import { CaretCircleDown } from '@phosphor-icons/react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { AccordionBlockProps } from '@/types';
import { SectionHeading } from '../ContentSection';

const HtmlContent = dynamic(() => import('../HtmlContent'));
const Heading = dynamic(() => import('../Heading'));

const AccordionBlock = ({
  title: accordionTitle,
  items,
}: AccordionBlockProps) => {
  const { t } = useTranslation('frontoffice');

  if (!items) {
    return null;
  }

  return (
    <>
      {accordionTitle ? (
        <SectionHeading as="h2" variant="h4">
          {accordionTitle}
        </SectionHeading>
      ) : null}
      <Accordion allowToggle variant="content">
        {items?.map(({ title, text }, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <AccordionItem key={`${title}-${i}`}>
            {({ isExpanded }) => (
              <>
                <Heading variant="h5" as="h3">
                  <AccordionButton cursor="pointer" py={[3, null, 5]} px={0}>
                    {title && (
                      <Flex flex="1" textAlign="left" alignItems="center">
                        <Text>{title}</Text>
                      </Flex>
                    )}
                    <Box
                      title={
                        isExpanded ? t('hide', 'Piilota') : t('show', 'Näytä')
                      }
                      aria-label={
                        isExpanded ? t('hide', 'Piilota') : t('show', 'Näytä')
                      }
                      transition="transform .25s ease-in-out"
                      transform={isExpanded ? 'rotate(-180deg)' : undefined}
                    >
                      <CaretCircleDown size="24" aria-hidden="true" />
                    </Box>
                  </AccordionButton>
                </Heading>
                <AccordionPanel
                  pt={3}
                  pb={5}
                  px={0}
                  display="flex"
                  flexWrap="wrap"
                  sx={{ '> *:first-child': { marginTop: '0' } }}
                >
                  <HtmlContent html={text} />
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};

export default AccordionBlock;
